import { render, staticRenderFns } from "./TermPicker.vue?vue&type=template&id=2f1955cf&scoped=true&"
import script from "./TermPicker.vue?vue&type=script&lang=js&"
export * from "./TermPicker.vue?vue&type=script&lang=js&"
import style0 from "./TermPicker.vue?vue&type=style&index=0&id=2f1955cf&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f1955cf",
  null
  
)

/* custom blocks */
import block0 from "./TermPicker.vue?vue&type=custom&index=0&blockType=i18n&lang=yaml"
if (typeof block0 === 'function') block0(component)

/* hot reload */
if (module.hot) {
  var api = require("/home/circleci/project/client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2f1955cf')) {
      api.createRecord('2f1955cf', component.options)
    } else {
      api.reload('2f1955cf', component.options)
    }
    module.hot.accept("./TermPicker.vue?vue&type=template&id=2f1955cf&scoped=true&", function () {
      api.rerender('2f1955cf', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/TermPicker/TermPicker.vue"
export default component.exports